const DEFAULT_PAGINATION_PAGE_COUNT = 1

const DEFAULT_PAGINATION_PAGE_INDEX = 1

const DEFAULT_PAGINATION_PAGE_SIZE = 100

const DEFAULT_PAGINATION_SORT: string[] = []

const API_ERROR_MESSAGE = 'Something went wrong. Please try again.'

const INVALID_UUID_ERROR_CODE = '22P02'

const OPTIMISTIC_UPDATE_DELAY = 1500

/**
 * Default page size for companies list
 */
const COMPANIES_PAGE_SIZE = 20

/**
 * Default page size for contacts list
 */
const CONTACTS_PAGE_SIZE = 50

/**
 * Default limit for reference data queries (categories, sectors, users, etc.)
 */
const REFERENCE_DATA_LIMIT = 50

/**
 * Limit for location data (larger to support client-side filtering)
 */
const LOCATION_DATA_LIMIT = 100

export {
  DEFAULT_PAGINATION_PAGE_COUNT,
  DEFAULT_PAGINATION_PAGE_INDEX,
  DEFAULT_PAGINATION_PAGE_SIZE,
  DEFAULT_PAGINATION_SORT,
  API_ERROR_MESSAGE,
  INVALID_UUID_ERROR_CODE,
  OPTIMISTIC_UPDATE_DELAY,
  COMPANIES_PAGE_SIZE,
  CONTACTS_PAGE_SIZE,
  REFERENCE_DATA_LIMIT,
  LOCATION_DATA_LIMIT,
}
